export default __webpack_public_path__ + "static/media/AT004.148e74d3.mp3";